export const shortDid = (did: string) => (did.length > 28 ? `${did.slice(0, 18)}…${did.slice(-6)}` : did);
/** The rail DID domain person DIDs are created on: VITE_RAIL_DID_DOMAIN, else
 *  the mock's test domain in `--mode mock`, else vouch.qseverse.com. */
export const railDomain: string = (import.meta.env?.VITE_RAIL_DID_DOMAIN as string | undefined)
  ?? (import.meta.env?.MODE === "mock" ? "vouch.qseverse.test" : "vouch.qseverse.com");
export function sha256File(file: File): Promise<string> {
  return file.arrayBuffer().then(async (b) => {
    const d = new Uint8Array(await crypto.subtle.digest("SHA-256", b));
    return "sha256:" + Array.from(d, (x) => x.toString(16).padStart(2, "0")).join("");
  });
}
